import EventEmitter from "events";

class BLEEventDispatcher extends EventEmitter {}

export default BLEEventDispatcher;
